import React, { Component } from 'react';
import { Modal, DatePicker, message, Spin, Input } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import moment from 'moment';

const dateFormat = "YYYY-MM-DD";
const { TextArea } = Input;

class RegisterTime extends Component {
    state = {
        list: [],
        params: {},
        visible: false,
        loading: false,
    }

    show = (params) => {
        this.setState({
            visible: true,
            params: {...params},
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params: { userId, independentInvTime, invUndertakeDescription } } = this.state;
        if (!independentInvTime) {
            return message.warning('独立承接项目时间不能为空')
        }
        if (!invUndertakeDescription) {
            return message.warning('承接情况说明不能为空')
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.setIndependentInvTime, {
            userId,
            independentInvTime: independentInvTime ? independentInvTime.slice(0, 10) : '',
            invUndertakeDescription,
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    getContent = () => {
        const { params } = this.state;
        const { independentInvTime, invUndertakeDescription } = params;
        const newPositiveTime = independentInvTime ? moment(independentInvTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}独立承接项目时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newPositiveTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "independentInvTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}承接情况说明:</div>
                    <div className="item-right">
                        <TextArea
                            placeholder='请输入'
                            rows={4}
                            value={invUndertakeDescription}
                            onChange={e => this.handleChange(e.target.value, 'invUndertakeDescription')}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="登记人员独立承接项目时间"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default RegisterTime;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/RegisterTime.js